import { Controller } from "@hotwired/stimulus"

// reCAPTCHA v3 is invisible/score-based — no widget to click, but the token
// still has to be fetched asynchronously (grecaptcha.execute) right before
// the form actually submits, since each token is single-use and tied to one
// specific action name. This intercepts the real submit, fetches a fresh
// token, drops it into the hidden field, then submits for real.
//
// Usage: data-controller="recaptcha" data-action="submit->recaptcha#handleSubmit"
// data-recaptcha-action-value="login" on the <form>, with a hidden field
// data-recaptcha-target="tokenField" inside it. Declared via data-action
// (rather than a self-registered listener) so its order relative to OTHER
// submit handlers on the same form — e.g. phone-input#split, which must
// run first so the split phone fields are populated before this re-submits
// — is controlled explicitly by the order they're listed in data-action.
//
// Loading Google's own script (api.js) is the one deliberate exception to
// this project's "nothing from a CDN" rule — reCAPTCHA is a live anti-bot
// verification service, not a static library that can be self-hosted.
export default class extends Controller {
  static targets = ["tokenField"]
  static values = { action: String, siteKey: String }

  handleSubmit(event) {
    if (this.submitting) return // token already fetched, let this second submit go through
    if (typeof window.grecaptcha === "undefined") return // reCAPTCHA not configured/loaded — submit normally

    event.preventDefault()
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(this.siteKeyValue, { action: this.actionValue }).then((token) => {
        this.tokenFieldTarget.value = token
        this.submitting = true
        this.element.requestSubmit()
      })
    })
  }
}
